import React from 'react';
import { GoogleLogin } from '@react-oauth/google';
import { jwtDecode } from 'jwt-decode';
import '../styles/AdminLogin.css';

const AdminLogin = ({ onLogin }) => {
  const [error, setError] = React.useState('');
  const [loading, setLoading] = React.useState(false);

  const handleGoogleLoginSuccess = async (credentialResponse) => {
    setLoading(true);
    setError('');

    try {
      // Decode the JWT token from Google
      const decoded = jwtDecode(credentialResponse.credential);
      
      const googleUser = {
        email: decoded.email,
        name: decoded.name,
        googleId: decoded.sub,
        picture: decoded.picture
      };

      console.log('Sending login request with email:', googleUser.email);

      // Send to backend for verification and session creation
      const response = await fetch('/api/admin/google-login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(googleUser)
      });

      const data = await response.json();
      console.log('Backend response:', data);

      if (response.ok) {
        onLogin();
      } else {
        setError(data.message || 'Login failed');
      }
    } catch (err) {
      console.error('Login error:', err);
      setError('Failed to login. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleGoogleLoginError = () => {
    setError('Google login failed. Please try again.');
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <div className="flex items-start gap-4 mb-6">
          <img src="/school.png" alt="Hope Haven Christian School" className="h-14 flex-shrink-0" />
          <div>
            <h1 className="text-2xl font-bold text-gray-800">Hope Haven Christian School</h1>
            <p className="text-gray-600">Admin Dashboard</p>
          </div>
        </div>
        <p>Sign in with your Hope Haven organization email</p>
        {error && <div className="error">{error}</div>}
        
        <div className="google-login-wrapper">
          {loading ? (
            <div className="loading-text">Signing in...</div>
          ) : (
            <GoogleLogin
              onSuccess={handleGoogleLoginSuccess}
              onError={handleGoogleLoginError}
              text="signin_with"
              size="large"
              theme="outline"
            />
          )}
        </div>

        <p style={{fontSize: '0.9em', color: '#666', marginTop: '20px'}}>
          Only registered admin users with @hopehavenschool.org email can access the dashboard.
        </p>
      </div>
    </div>
  );
};

export default AdminLogin;
